import React from "react";
import styled from "styled-components";
import FilterSection from "../components/FilterSection";
import ProductList from "../components/ProductList";
import Sort from "../components/Sort";
import { useFilterContext } from "../context/filter_context";

const Products = () => {
  
  return <Wrapper>
    <div className="container-product">
      <div className="filterSection">
       <FilterSection />
      </div>
      <div className="product-view--sort">
        <div className="sort-filter">
          <Sort />
        </div>
        <div className="main-product">
          <ProductList />
        </div>
      </div>
    </div>
    
  </Wrapper>;
};

const Wrapper = styled.section`
  margin:0.5rem 12rem;
  
  
.container-product {
  display: grid;
  grid-template-columns: 2.5fr 7.5fr;
  margin-top: 3rem;
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
  padding:1rem;
  margin : 0.5rem;
  
  .container-product  {
   grid-template-columns: 1fr;
   gap:1rem;
   margin-top: 0rem;
   }
  }
`;

export default Products;
